import { render } from "./nuevoPresupuesto.vue?vue&type=template&id=58a70fd3&scoped=true"
import script from "./nuevoPresupuesto.vue?vue&type=script&lang=js"
export * from "./nuevoPresupuesto.vue?vue&type=script&lang=js"

import "./nuevoPresupuesto.vue?vue&type=style&index=0&id=58a70fd3&scoped=true&lang=css"
import "./nuevoPresupuesto.vue?vue&type=style&index=1&id=58a70fd3&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58a70fd3"]])

export default __exports__